import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import { Code } from './src/components/code'

// Extracts the code string and language from the `<pre><code>` elements
// generated by MDX for fenced code blocks.
function preToCodeBlock(preProps) {
  const child = preProps.children
  if (
    child &&
    child.props &&
    typeof child.props.children === 'string'
  ) {
    const { children: codeString, className = '' } = child.props
    const match = className.match(/language-([\w-]+)/)
    return {
      codeString: codeString.trimEnd(),
      // Prism language names are lowercase (```Lean → lean)
      language: match ? match[1].toLowerCase() : '',
    }
  }
  return undefined
}

// components is its own object outside of render so that the references to
// components are stable
const components = {
  pre: preProps => {
    const props = preToCodeBlock(preProps)
    // if there's a codeString and some props, we passed the test
    if (props) {
      return <Code {...props} />
    } else {
      // it's possible to have a pre without a code in it
      return <pre {...preProps} />
    }
  },
}
export const wrapRootElement = ({ element }) => (
  <MDXProvider components={components}>{element}</MDXProvider>
)
